import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { RouteComponentProps } from 'react-router'

import { LoaderSpinner } from '../atoms/LoaderSpinner'
import { useRoot } from '../atoms/RootProvider'
import { RedirectToLogin } from '../routes/RedirectToLogin'

interface IProps extends RouteComponentProps {}

export const LogoutPage: React.SFC<IProps> = () => {
  const { auth } = useRoot()
  React.useEffect(() => {
    auth.logout()
  }, [])
  return useObserver(() =>
    auth.isAuthenticated ? <LoaderSpinner /> : <RedirectToLogin />,
  )
}
